<template>
  <router-link
    v-if="!external && isClickable"
    :to="$localePath({ name: link, query: $route.query })"
  >
    <v-img v-bind="commonProps" />
  </router-link>
  <a v-else-if="external && isClickable" :href="link" :target="externalLogoTarget">
    <v-img v-bind="commonProps" />
  </a>
  <v-img v-else v-bind="commonProps" />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Logo',
  props: {
    link: {
      type: String,
      default: 'index'
    },
    external: {
      type: Boolean,
      default: false
    },
    externalLogoTarget: {
      type: String,
      default: '_blank'
    },
    mobile: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [Number, String],
      required: false
    },
    height: {
      type: [Number, String],
      default: 31
    },
    isClickable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      header: 'general/header'
    }),
    commonProps() {
      const title = this.$t('uLekare.title', this.$domainRegion === 'sk' ? 'sk' : 'cs');
      return {
        width: this.mobile ? 48 : 145,
        maxWidth: this.maxWidth,
        height: this.height,
        contain: true,
        src: this.logoImg,
        alt: title,
        title,
        class: 'logo'
      };
    },
    logoImg() {
      if (this.isUlHc) {
        return this.$asset('img/logos/ulekare_hc-logo.svg');
      }

      if (this.mobile) {
        return this.$asset('img/logos/ulekare-logo.svg');
      }

      if (this.$domainRegion === 'hu') {
        return this.$asset('img/logos/soulody-hu-logo.svg');
      }

      if (this.$domainRegion === 'sk') {
        return this.$asset('img/logo-sk.svg');
      }

      return this.$asset(
        `img/logo${
          this.$domainRegion !== 'cz' && this.header === 'mastercard'
            ? `-${this.$domainRegion}`
            : ''
        }.svg`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  display: block;

  .header & {
    width: 163px;
    height: 31px;
    margin-top: 8px;
  }

  .footer & {
    width: 214px;
    height: 42px;
  }
}
</style>
